import { queryClient } from '@/lib/query-client';
import {
  MutationObserver,
  MutationObserverOptions,
} from '@tanstack/query-core';

type MutationContext = {
  previousData?: unknown;
};

export function executeMutation<
  TData = unknown,
  TError = Error,
  TVariables = void,
  TContext = MutationContext,
>(
  options: MutationObserverOptions<TData, TError, TVariables, TContext>,
  variables: TVariables,
): Promise<TData> {
  const mutationObserver = new MutationObserver<
    TData,
    TError,
    TVariables,
    TContext
  >(queryClient, options);

  return mutationObserver.mutate(variables);
}
